/* eslint-disable promise/catch-or-return,promise/always-return */
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../Button';
import Popup from '../common/Popup';
import { isDesktop } from '../../utils/mobileHelpers';
import { getAllMediaDevices } from '../../redux/opentok/helpers/utils';
import { devicePermissionActions } from '../../redux/healthboard/devicePermissions';
import {
  DEVICE_PERMISSION_TYPES,
  getDeniedPermissionData,
  getRequestPermissionData,
  hasDevicePermissions,
} from '../../redux/opentok/helpers/devicePermissionHelper';
import {
  selectDevicePerissionModalOpened,
  selectDevicePerissionModalProps,
} from '../../redux/healthboard/selectors';
import styles from './styles.styl';

function DevicePermissions({ type, invitable }) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const close = () => dispatch(devicePermissionActions.close());

  useEffect(() => {
    const isDenied = type === DEVICE_PERMISSION_TYPES.DENIED;
    let timer;

    function tick() {
      getAllMediaDevices().then(devices => {
        const hasPermission = hasDevicePermissions(devices);
        if (hasPermission) {
          dispatch(devicePermissionActions.mediaPermissionsGranted());
        }
        return devices;
      });
    }
    if (isDenied) {
      timer = setInterval(tick, 1000);
    }

    return () => {
      if (isDenied) clearInterval(timer);
    };
  }, [type]);

  const { title, description, src } = useMemo(() => {
    if (type === DEVICE_PERMISSION_TYPES.REQUEST) {
      return getRequestPermissionData();
    }
    return getDeniedPermissionData();
  }, [type]);

  const handleCTA = () => {
    if (invitable) {
      dispatch(devicePermissionActions.retry());
      return;
    }

    close();
  };

  return (
    <Popup
      opened
      autoHeight
      withHeading={false}
      dialogClassName={styles.dialog}
      width={isDesktop() ? 'auto' : 'medium'}
      paperClassName={styles.root}
    >
      <div className={styles.title}>{formatMessage({ id: title })}</div>
      <div className={styles.content}>{formatMessage({ id: description })}</div>
      {src && (
        <div className={styles.image}>
          <img alt="preview" src={src} />
        </div>
      )}
      <div className={styles.button}>
        <Button color="primary" onClick={handleCTA}>
          {formatMessage({
            id: invitable ? 'common.tryAgain' : 'common.gotIt',
          })}
        </Button>
      </div>
    </Popup>
  );
}

DevicePermissions.propTypes = {
  invitable: PropTypes.bool,
  type: PropTypes.oneOf([
    DEVICE_PERMISSION_TYPES.REQUEST,
    DEVICE_PERMISSION_TYPES.DENIED,
  ]),
};

function DevicePermissionsPopup() {
  const opened = useSelector(selectDevicePerissionModalOpened);
  const props = useSelector(selectDevicePerissionModalProps);

  if (!opened) return null;

  return <DevicePermissions {...props} />;
}

export default DevicePermissionsPopup;



// WEBPACK FOOTER //
// ./src/components/DevicePermissionsPopup/index.jsx